import { render, staticRenderFns } from "./DropdownOptionGroup.vue?vue&type=template&id=108a51ea"
import script from "./DropdownOptionGroup.vue?vue&type=script&lang=js"
export * from "./DropdownOptionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports